import { IReducerState } from 'store/main-reducer';
import { AddressPrediction, AddressDetails } from 'types';

export const getAddressLookupIsLoading = (state: IReducerState): boolean => state.addressLookupReducer.isLoading;
export const getAddressLookupError = (state: IReducerState): string | undefined => state.addressLookupReducer.error;
export const getAddressLookupResults = (state: IReducerState): AddressPrediction[] => state.addressLookupReducer.addressResults;
export const getAddressDetails = (state: IReducerState): AddressDetails | undefined => state.addressLookupReducer.details;
